import axios from 'axios'
import Tip from '../config/Tip'
import qs from 'qs'
import store from '../store'
import router from 'vue-router'

import { Loading } from "element-ui"


let baseUrl = process.env.BASE_API

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.withCredentials = true
let instance = {};
let loadingInstance;


// 入参格式为json
instance.postType = function(api, params = {}, config = {}) {
    let paramData = params
    let uuid = window.sessionStorage.getItem('uuid');
    if (uuid !== '') {
        axios.defaults.headers.common['session-token'] = uuid;
    }
    if (config.showLoading) {
        loadingInstance = Loading.service({ fullscreen: true, text: '正在请求服务器,请等待...' })
    }
    return new Promise(function(resolve, reject) {
        axios({
            method: 'POST',
            url: baseUrl + api,
            data: paramData
        }).then(function(res) {
            let data = res.data
            if (data === null || data === undefined || data === '' || data.code == 401) {

                // Tip.tip('用户失效,请重新登录')

                // router.replace("/login");
                // router.push("/login");
                //
            } else {
                resolve(data)
            }

            if (loadingInstance) {
                loadingInstance.close()
            }
        }).catch(function(error) {
            console.log(error)
            console.log(error.response)
            if (error.response.status == 401) {}
        })
    }).catch(function(err) {
        if (loadingInstance) {
            loadingInstance.close()
        }
        Tip.tip('服务端异常，请稍后重试')
    })
}

// 入参格式为表单
instance.postType2 = function(api, params = {}, ContentType) {
    let paramData = params
    // let cache = localStorage.getItem('CACHE') || ''
    // let token = localStorage.getItem('token') || ''
    axios.defaults.withCredentials = true
    // if (cache !== '') {
    //     axios.defaults.headers.common['Employee-Cache'] = cache
    // }
    // if (token !== '') {
    //     axios.defaults.headers.common['yian-cache'] = token
    // }
  let uuid = window.sessionStorage.getItem('uuid');
  if (uuid !== '') {
    axios.defaults.headers.common['session-token'] = uuid;
  }
    return new Promise(function(resolve, reject) {
        axios({
            method: 'POST',
            url: baseUrl + api,
            data: qs.stringify(paramData),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(function(res) {
            let data = res.data
            if (data === null || data === undefined || data === '' || data.code == 401) {

                // Tip.tip('用户失效,请重新登录')

            } else {
                resolve(data)
            }
        }).catch(function(error) {
            console.log(error)
            console.log(error.response)
            if (error.response.status == 401) {}
        })
    }).catch(function(err) {
        Tip.tip('服务端异常，请稍后重试')
    })
}

// 返回res，为登录单独处理的
instance.postType3 = function(api, params = {}) {
    let paramData = params
    axios.defaults.withCredentials = true
    return new Promise(function(resolve, reject) {
        axios({
            method: 'POST',
            url: baseUrl + api,
            data: paramData
        }).then(function(res) {
            resolve(res)
        }).catch(function(error) {
            console.log(error)
            console.log(error.response)
            if (error.response.status == 401) {

            }
        })
    }).catch(function(err) {
        Tip.tip('服务端异常，请稍后重试')
    })
}

instance.getType = function(api, params = {}, extConfig = {}) {
    let paramData = params

  let uuid = window.sessionStorage.getItem('uuid');
  if (uuid !== '') {
    axios.defaults.headers.common['session-token'] = uuid;
  }
    let config = {
        method: 'get',
        url: baseUrl + api,
        params: paramData,
    }

    config = Object.assign(config, extConfig)
    return new Promise(function(resolve, reject) {
        axios(config).then(function(res) {
            let data = res.data
            if (data === null || data === undefined || data === '' && token || data.code == 401) {

                // router.push("/login");
            } else {
                if (extConfig.completeData) {
                    data = res
                }
                // setTimeout(() => {
                resolve(data)

                // }, 1000)
            }
        }).catch(function(error) {
            if (error.response.status == 401) {

            }
        })
    }).catch(function(err) {
        Tip.tip('服务端异常，请稍后重试')
    })
}

instance.getType3 = function(api, params = {}, extConfig = {}) {
    axios.defaults.withCredentials = true
    let paramData = params
    let config = {
        method: 'get',
        url: baseUrl + api,
        params: paramData,
    }
    config = Object.assign(config, extConfig)
    return new Promise(function(resolve, reject) {
        axios.defaults.withCredentials = true
        axios(config).then(function(res) {
            resolve(res)
        }).catch(function(error) {
            if (error.response.status === 401) {}
        })
    }).catch(function(err) {
        Tip.tip('服务端异常，请稍后重试')
    })
}
export default instance



// WEBPACK FOOTER //
// ./src/config/service2.js